// extracted by mini-css-extract-plugin
export var badge = "cart-button-module--badge--UKrhJ";
export var cartButton = "cart-button-module--cartButton--m4LbS";